// The visit gate (showcase look, 15 Oct; on by default since Antonin's "yes", 15 Oct): the appointment popup's "Enter
// encounter" is shown for a booking that is not ready yet, disabled, with the reason beside it. Same pattern as
// `encounter-flags.ts`, but ON unless this browser turned it off:
//   ?x=-visit-gate   turn it off (remembered in this browser)
//   ?x=visit-gate    turn it back on
// Storage can be missing or blocked, so every read and write is guarded and a failure reads as the default (ON).
import { useState } from 'react';

export const VISIT_GATE_PARAM = 'x';
export const VISIT_GATE_NAME = 'visit-gate';
const STORAGE_KEY = 'scrips.visitGate';

function readStored(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) !== 'off';
  } catch {
    return true;
  }
}

function writeStored(on: boolean): void {
  try {
    if (on) window.localStorage.removeItem(STORAGE_KEY);
    else window.localStorage.setItem(STORAGE_KEY, 'off');
  } catch {
    // Storage unavailable: the switch stays as it was (ON unless already stored off).
  }
}

/** Applies any `x` query parameters to the stored switch. Unknown names are ignored. */
export function applyVisitGateParams(search: string): void {
  for (const entry of new URLSearchParams(search).getAll(VISIT_GATE_PARAM)) {
    if (entry === VISIT_GATE_NAME) writeStored(true);
    else if (entry === `-${VISIT_GATE_NAME}`) writeStored(false);
  }
}

/** True unless this browser has turned the gate off. */
export function isVisitGateOn(): boolean {
  if (typeof window === 'undefined') return true;
  applyVisitGateParams(window.location.search);
  return readStored();
}

/** Read once per mount, so a popup never flips look half-way through a render tree. */
export function useVisitGate(): boolean {
  const [on] = useState(() => isVisitGateOn());
  return on;
}
